<template>
    <div>
        <StepHeader
            :subtitle="subtitle"
            :description="description"
        />
        <StepBtnGroup
            class="mt-6 step-group media"
            :fields="fields"
            :selectedValue="selectedMedia"
            :orientation="'column'"
            layout="'full-width'"
            @select-value="selectMedia"
        />
        <StepSaveByDefaultCheckbox 
            :selectedOption="selectedMedia" 
            stepId="media"
            :label="$t('habiteoStudio.saveFileTypeByDefault')"
        />
    </div>
</template>

<script>
    import StepHeader from '@/components/myHabiteoStudio/steps/components/StepHeader';
    import StepBtnGroup from '@/components/myHabiteoStudio/steps/components/StepBtnGroup';
    import StepSaveByDefaultCheckbox from '@/components/myHabiteoStudio/steps/components/StepSaveByDefaultCheckbox';
    import { mapGetters } from 'vuex';
    export default {
        name: 'StepMedia',
        components: {
            StepHeader,
            StepBtnGroup,
            StepSaveByDefaultCheckbox
        },
        props: {
            subtitle: {
                type: String,
                required: true
            },
            description: {
                type: String,
                required: true
            },
            forms: {
                type: Array,
                required: true
            },
            selectedMedia: {
                type: Number,
                required: false
            }
        },
        data() {
            return {
                storageKey: 'myHabiteo-studio-step-media'
            }
        },
        computed: {
            ...mapGetters(['isLocalstorageAvailable']),
            fields() {
                return this.$props.forms[0].inputs[0].fields;
            }
        },
        mounted() {
            const storageValue = this.isLocalstorageAvailable ? JSON.parse(localStorage.getItem(this.storageKey)): null;
            const defaultValue = this.$props.forms[0].inputs[0].value || storageValue || this.$props.forms[0].inputs[0].fields[0].value;
            this.selectMedia(defaultValue);
        },
        
        methods: {
            selectMedia(media) {
                this.$props.forms[0].inputs[0].value = media;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/myHabiteoStudio/steps/StepMedia.vue